/* eslint-disable no-undef */
/* eslint-disable camelcase */
import $ from '@rover/globals/jquery';
import Alerts from '@rover/utilities/Alerts';
import emitMetric from '@rover/utilities/emitMetric';
import { getQueryParams } from '@rover/utilities/url';

(function () {
  'use strict';

  function init() {
    const $form = $('.js-instapage-sign-up-form');
    const $submit = $form.find('[type="submit"]');

    const initializeSignUpValidation = () => {
      $form.roverValidate({
        focusInvalid: false,
        rules: {
          phone_number: 'phoneUS',
          zip_code: {
            required: true,
            remote: {
              url: Rover.marketingUrls.validateZipcode,
              type: 'GET',
              data: {
                remote: true,
                cache: false,
                country_code() {
                  return $('.js-intl-country-code').val();
                },
                locale() {
                  return $('.js-intl-locale').val();
                },
              },
            },
          },
          password: {
            required: true,
            remote: {
              url: Rover.marketingUrls.validatePassword,
              type: 'POST',
              data: {
                remote: true,
                cache: false,
                locale() {
                  return $('.js-intl-locale').val();
                },
              },
            },
          },
          reenter_partnership_program_number: {
            required: true,
            equalTo: '[name="partnership_program_number"]',
          },
          experience_environments: {
            require_from_group: [1, '[name="experience_environments"]'],
          },
          agree_to_tos: {
            required: $('#id_agree_to_tos').length,
          },
        },
        messages: {
          agree_to_tos: {
            required: Rover.context.tosError,
          },
        },
      });
    };

    const setFieldsFromIntl = () => {
      const query_params = getQueryParams();
      const locale_param = Array.isArray(query_params.locale)
        ? query_params.locale[query_params.locale.length - 1]
        : query_params.locale;
      const locale = locale_param || 'en_US';
      const localeRegex = /[a-z]{2}_[A-Z]{2}/;

      if (localeRegex.test(locale)) {
        const locale_parts = locale.split('_');
        const country_code = (
          locale_parts.length > 1 ? locale_parts[1] : locale_parts
        ).toUpperCase();

        $('.js-intl-locale').each((i, el) => $(el).val(locale));
        $('.js-intl-country-code').each((i, el) => $(el).val(country_code));
      }

      if (window.Intl) {
        const resolvedOptions = Intl.DateTimeFormat().resolvedOptions();
        $('.js-intl-time-zone').each((i, el) => $(el).val(resolvedOptions.timeZone));
      }
    };

    /**
     * We clear the errors by calling "show errors",
     * with an empty string as error for each field.
     * We do this to trigger the native error check in the validation plugin
     */
    const clearFormErrors = () => {
      const validator = $form.data('validator');
      const errorKeys = Object.keys(validator.errorMap);
      const emptyErrors = errorKeys.reduce((acc, key) => {
        acc[key] = '';
        return acc;
      }, {});

      validator.showErrors(emptyErrors);
    };

    const initializeAjaxForm = () => {
      $form.on('submit', () => {
        $submit.attr('disabled', 'disabled');
      });
      $form.ajaxForm({
        dataType: 'json',
        // eslint-disable-next-line consistent-return
        beforeSubmit() {
          clearFormErrors();

          if (!$form.valid()) {
            $submit.removeAttr('disabled');
            return false;
          }
        },
        success(data) {
          window.parent.window.location.href = data.redirect_url;
        },
        error({ responseJSON }) {
          if (responseJSON) {
            const { __all__: general_errors, ...field_errors } = responseJSON.errors;
            $form.data('validator').showErrors(field_errors);
            if (Array.isArray(general_errors)) {
              Alerts.showToast({
                severity: 'danger',
                message: general_errors.join('\n'),
                showHideButton: false,
              });
            }
          }
          $submit.removeAttr('disabled');
        },
      });
    };

    const initializeLocaleSelector = () => {
      $('.js-locale-selector').on('change', () =>{
        // Disable the form while the locale is being changed
        $submit.attr('disabled', true);
        $form.find(':input').attr('disabled', true);

        const url = new URL(window.location.href);
        const locale = $('.js-locale-selector').val();
        url.searchParams.set('locale', locale);
        window.location.href = url;
      });
    }

    initializeLocaleSelector();
    initializeAjaxForm();
    initializeSignUpValidation();
    setFieldsFromIntl();
    try {
      emitMetric('instapage.marketing_signup.init', { pathname: window.top.location.pathname });
    } catch (error) {
      emitMetric('instapage.marketing_signup.error');
    }
  }
  init();
})();
